import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FilterButton from './FilterButton';
import FilterMultiSelectItem from './FilterMultiSelectItem';

const FilterMultiSelect = ({
  selected,
  options,
  onChange,
  label = '',
  inline,
  invert,
  isMapPage = false,
}) => {
  const [open, setOpen] = useState(false);

  if (!options) return null;

  const onChangeAction = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter((option) => option !== value));
    } else {
      const selectedCategories = [...selected, value];
      onChange(selectedCategories);
    }
  };

  const list = (
    <ul className="select-menu__list">
      {options.map((item) => {
        const isSelected = selected.includes(item.value);

        return (
          <FilterMultiSelectItem
            inline={inline}
            invert={invert}
            isMapPage={isMapPage}
            isSelected={isSelected}
            item={item}
            key={item.value}
            onSelect={onChangeAction}
          />
        );
      })}
      <style jsx>{`
        .select-menu__list {
          font-size: 15px;
          list-style: none;
          padding: ${inline ? 0 : '0 40px 10px 32px'};
          margin-bottom: ${inline ? 0 : 10}px;
        }
      `}</style>
    </ul>
  );

  if (inline) {
    return list;
  }

  return (
    <>
      <FilterButton
        isMapPage={isMapPage}
        label={`${label} (${
          selected.length === 0 ? 'All' : selected.length + ' Selected'
        })`}
        onClick={() => setOpen((opened) => !opened)}
        open={open}
      >
        {list}
      </FilterButton>
    </>
  );
};

FilterMultiSelect.propTypes = {
  inline: PropTypes.bool,
  invert: PropTypes.bool,
  isMapPage: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string),
};

export default FilterMultiSelect;
